import * as React from 'react';
const NylasContext = React.createContext(null);
export const useNylas = () => React.useContext(NylasContext);
export default NylasContext;
